export enum OperationApproveStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}
